export default "__VITE_ASSET__7S2xCxb6__"